<nw-content-block [border]="border" [heading]="title">
    <div class="nw-click-dimensions-block__container">
        @if (topcontent) {
            <div
                [innerHTML]="topcontent | sanitizeHtml"
                [class.margin-bottom-xl]="!bottomcontent && !clickdimensionsurl"
            ></div>
        }
        @if (clickdimensionsurl) {
            <div class="margin-bottom-xl margin-top-xl">
                <iframe
                    #iframe
                    class="nw-click-dimensions-block__container__iframe"
                    width="100%"
                    [attr.height]="(height ? height + 'px' : undefined) || '100%'"
                    type="text/html"
                    [src]="clickdimensionsurl | sanitizeUrl"
                    frameborder="0"
                    style="border: 0"
                    allowtransparency="true"
                ></iframe>
            </div>
        }
        @if (bottomcontent) {
            <div [innerHTML]="bottomcontent | sanitizeHtml"></div>
        }
    </div>
</nw-content-block>
